import { LiliMask } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { OnboardingFormFields } from '@Types/index.ts';
import { ControlledMaskedInput } from '@Components/inputs/ControlledInputs';
import { DATE_FORMAT_HINT } from '@Consts/constants';
import { SSNInput } from '@Components/inputs/SSNInput';

export const IdentityUsForm = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const dateOfBirthValue = watch(OnboardingFormFields.DATE_OF_BIRTH);

  return (
    <>
      <div className='relative'>
        <SSNInput />
      </div>
      <ControlledMaskedInput
        mask={LiliMask.DATE}
        name={OnboardingFormFields.DATE_OF_BIRTH}
        id={OnboardingFormFields.DATE_OF_BIRTH}
        title={
          dateOfBirthValue
            ? `${t('pages.identity.bdFieldTitle')} (${DATE_FORMAT_HINT})`
            : t('pages.identity.bdFieldTitle')
        }
        hint={DATE_FORMAT_HINT}
        props={{ showClear: false }}
        isPublic={false}
      />
    </>
  );
};
